import { ActionTree } from 'vuex'
import RootState from '@vue-storefront/core/types/RootState'
import TransportState from '../types/TransportState'
import { processURLAddress } from '@vue-storefront/core/helpers'
import fetch from 'isomorphic-fetch'
import config from 'config'
import * as types from './mutation-types'
import rootStore from '@vue-storefront/core/store'

const actions: ActionTree<TransportState, RootState> = {
  loadActiveTransport ({ commit }) {
     let url = processURLAddress(`${config.transport.base_endpoint}/getActiveTransport`)
     return fetch(url, {
       method: 'GET'
     })
      .then(resp => resp.json())
      .then(response => {
        if (!response.result.status || response.result.status !== 'error' ) {
          commit(types.SET_TRANSPORT, response.result.data)
        }
        return response
      })
      .catch(error => {
        throw new Error('FetchError in request: ' + error.toString())
      })
  }
}

export default actions
